import {
    SET_DISPOSITION_PENALTY_FEE, SET_PENALTY_GLOBAL_FLAG,
    SET_DISPOSITION_EQUIPMENT_CLASS,
    SET_DISPOSITION_PENALTY_FEE_GRID_DATA, SET_DISPOSITION_TYPE
} from "./DispositionPenaltyFeeType";

const reducer = (state = [], action: any) => {
    switch (action.type) {
        case SET_DISPOSITION_PENALTY_FEE:
            return {
                ...state,
                dispositionPenaltyFee: action.dispositionPenaltyFee
            };
        case SET_PENALTY_GLOBAL_FLAG:
            return {
                ...state,
                globalPenaltyFlag: action.globalPenaltyFlag,
            };
        case SET_DISPOSITION_PENALTY_FEE_GRID_DATA:
            return {
                ...state,
                dispositionPenaltyFeeGridData: action.gridData
            };
        case SET_DISPOSITION_EQUIPMENT_CLASS:
            return {
                ...state,
                dispositionEquipmentClassList: action.dropdownData
            };
        case SET_DISPOSITION_TYPE:
            return {
                ...state,
                dispositionTypeList: action.dropdownData
            };
        default:
            return state;
    }
};

export default reducer;
